import { render, staticRenderFns } from "./DateRangeSelector.vue?vue&type=template&id=99abc090&scoped=true&"
import script from "./DateRangeSelector.vue?vue&type=script&lang=js&"
export * from "./DateRangeSelector.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeSelector.vue?vue&type=style&index=0&id=99abc090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99abc090",
  null
  
)

/* custom blocks */
import block0 from "./DateRangeSelector.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./DateRangeSelector.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QBtnDropdown,QCard,QCardSection,QSelect,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnDropdown,QCard,QCardSection,QSelect,QCardActions,QBtn})
